import service from '@/store/services/fms/city-service';

const state = {
  list: {},
  city: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, city) => {
    state.city = city;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((city) => { commit('SET_RESOURCE', city); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((city) => { commit('SET_RESOURCE', city); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((city) => { commit('SET_RESOURCE', city); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  city: state => state.city,
};
 
const city = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default city;
